import { LightboxElement } from './lightbox';

import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('lightbox-toggle')
export class LightboxToggle extends LitElement {

    // Props

    @property({ type: String })
    target?: string;

    @property({ type: Number })
    index?: number;

    // Lifecycle Hooks

    firstUpdated() {
        this.classList.add('LightboxToggle');
        const lightbox: LightboxElement = document.querySelector(`lightbox-element[data-id="${ this.target }"]`);
        this.addEventListener('click', () => {
            lightbox.activeIndex = this.index;
            lightbox.open();
        });
    }

    // Render

    createRenderRoot() {
        return this;
    }

}